import React, { useState } from "react";
import GirlSmiling from "../../assets/images/businesswoman-posing.jpg";

export default function HowItWorks() {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <section className="relative py-10 xl:py-24 px-6 overflow-hidden">
      {/* Grid background */}
      <div className="absolute inset-0" />

      <div className="relative max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
        {/* RIGHT CONTENT – FIRST ON MOBILE */}
        <div className="order-1 lg:order-2 text-center lg:text-left">
          <p
            className="flex items-center justify-center lg:justify-start gap-2 text-[16px] font-medium text-[#F8F8F8] leading-[1.4em] mb-4"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <span className="w-2.5 h-2.5 rounded-full bg-[#86ff9f]" />
            How it work
          </p>

          <h2
            className="text-[24px] md:text-[32px] xl:text-[42px] font-semibold leading-[1.2em] text-[#F8F8F8] mb-6"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            How I build <br />
            <span className="bg-gradient-to-r from-[#6cfcb5] to-[#F0FF6C] bg-clip-text text-transparent">
              web applications
            </span>
          </h2>

          <p
            className="text-[#F8F8F8] font-normal mb-10"
            data-aos="fade-up"
            data-aos-delay="400"
          >
            As a{" "}
            <span className="bg-gradient-to-r from-[#6cfcb5] to-[#F0FF6C] bg-clip-text text-transparent underline font-semibold">
              MERN Stack Developer
            </span>
            , I follow a structured development workflow that transforms ideas
            into scalable and reliable web applications using modern JavaScript
            technologies.
          </p>

          {/* Steps */}
          <div
            className="pt-6 space-y-4"
            data-aos="fade-up"
            data-aos-delay="500"
          >
            {[
              {
                title: "Planning & Requirement Analysis",
                content:
                  "I understand project requirements, define goals, and plan the application structure before starting development.",
              },
              {
                title: "Development & Implementation",
                content:
                  "I build responsive frontend interfaces and scalable backend systems using MERN stack technologies.",
              },
              {
                title: "Testing & Deployment",
                content:
                  "I test application functionality, fix issues, and deploy the project to ensure smooth performance.",
              },
            ].map((item, index) => {
              const isOpen = activeIndex === index;

              return (
                <div key={index} className="border-b border-white/10 pb-5">
                  {/* Header */}
                  <button
                    onClick={() => setActiveIndex(isOpen ? null : index)}
                    className="w-full flex items-center justify-between text-left"
                  >
                    <span className="text-[#F8F8F8] text-[18px] md:text-[20px] font-semibold leading-[1.4em]">
                      {index + 1}. {item.title}
                    </span>

                    <span
                      className={`text-[#6cfcb5] transition-transform duration-300 ${
                        isOpen ? "rotate-180" : "rotate-0"
                      }`}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M10.9999 4.55961C10.9999 6.90009 8.77884 9.03321 6.33984 9.03321H5.33984V10.9532H6.33984C8.11384 10.9532 9.77784 10.2063 10.9999 9.03417V20.8796H12.9999V9.03417C14.2219 10.2063 15.8859 10.9532 17.6599 10.9532H18.6599V9.03321H17.6599C15.2209 9.03321 12.9999 6.90009 12.9999 4.55961V3.59961H10.9999V4.55961Z"
                          fill="currentColor"
                        />
                      </svg>
                    </span>
                  </button>

                  <div
                    className={`overflow-hidden transition-all duration-300 ${
                      isOpen ? "max-h-40 mt-4" : "max-h-0"
                    }`}
                  >
                    <p className="text-[#F8F8F8] text-[16px] leading-[1.6em]">
                      {item.content}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* LEFT IMAGE – SECOND ON MOBILE */}
        <div className="relative order-2 lg:order-1 flex justify-center">
          <figure className="relative group overflow-hidden rounded-[28px]">
            <img
              src={GirlSmiling}
              alt="How it works"
              className="
        rounded-[28px] object-cover
        w-full max-w-[320px]
        sm:max-w-[400px]
        md:max-w-[480px]
        lg:max-w-full
      "
            />

            {/* Shine sweep */}
            <div
              className="
        pointer-events-none
        absolute top-0 left-[-75%]
        h-full w-1/2
        bg-gradient-to-r from-white/0 via-white/30 to-white/0
        skew-x-[-25deg]
        group-hover:animate-shine
      "
            />
          </figure>
        </div>
      </div>
    </section>
  );
}
